//NO USER ROUTES
export const REGISTER = '/register';
export const LOGIN = '/';
export const FORGOT_PASSWORD = '/forgot_password';
export const PASSWORD_RESET = '/password_reset';
export const VERIFY_EMAIL = '/verify_email';
//LOGGED IN USER ROUTES
export const DASHBOARD = '/dashboard';
export const PROJECT_SETUP = '/project_setup';
export const PROJECT_CYCLES = '/project_cycles';
export const CYCLE_TASK = '/cycle_task';
export const WORKER_TASK_LIST = '/worker_task_list';
export const WORKER_TASK_DETAIL = '/worker_task_detail';
export const DOCUMENTS = '/documents';
export const TEAM = '/team';
export const TASKS = '/tasks';
export const TEST = '/test';




// WEBPACK FOOTER //
// ./src/routes/routes.js